<template>
  <v-card>
    <v-tabs
      v-model="active"
      background-color="transparent"
      grow
      show-arrows
      color="hrissecondary"
    >
      <v-tab
        v-for="item in filteredTabItems"
        :key="item.name"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="active">
      <v-tab-item
        v-if="$hasPermissionTo(['view branches'])"
        class="pb-12"
      >
        <setup-companies-branches-container-view
          :company="company"
        />
      </v-tab-item>
      <v-tab-item
        v-if="$hasPermissionTo(['view cost centers'])"
        class="pb-12"
      >
        <setup-companies-cost-centers-container-view
          :company="company"
        />
      </v-tab-item>
      <v-tab-item
        v-if="$hasPermissionTo(['view company banks'])"
        class="pb-12"
      >
        <setup-companies-banks-container-view
          :company="company"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
  export default {
    components: {
      SetupCompaniesBranchesContainerView: () => import('@/components/hris/setup/companies/branches/ContainerView'),
      SetupCompaniesCostCentersContainerView: () => import('@/components/hris/setup/companies/cost-centers/ContainerView'),
      SetupCompaniesBanksContainerView: () => import('@/components/hris/setup/companies/banks/ContainerView'),
    },
    props: {
      company: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view branches'])) {
          modifiedTab.push({ name: 'Branches' })
        }
        if (this.$hasPermissionTo(['view cost centers'])) {
          modifiedTab.push({ name: 'Cost Centers' })
        }
        if (this.$hasPermissionTo(['view company banks'])) {
          modifiedTab.push({ name: 'Banks' })
        }

        return modifiedTab
      },
    },
  }
</script>
